import { SALE_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
export var useIsSaleHub = function() {
    var _categoryModel_urlId;
    var categoryModel = useCurrentCategoryModel();
    var isSaleHub = ((_categoryModel_urlId = categoryModel.urlId) === null || _categoryModel_urlId === void 0 ? void 0 : _categoryModel_urlId.id) === SALE_CATEGORY_URL_ID;
    var isPrimaryCategory = categoryModel.isPrimaryCategory;
    return {
        isSaleProductCategory: isSaleHub && !isPrimaryCategory
    };
};
